import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpParams, HttpClient } from '@angular/common/http';
import { GlobalProvider } from '../../providers/global/global';
import { FormBuilder , Validators, FormGroup, AbstractControl} from '@angular/forms';

/**
 * Generated class for the ForgotPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  formgroup: FormGroup;
  email: AbstractControl ;
  emailTXT: string = '';
  portal: string = '';
  btnColor: string = '';
  cardcontent: string = 'Please enter your email to receive instructions on how to reset your password.';
  showEmail:boolean = true;
  constructor(public navCtrl: NavController
            , public navParams: NavParams
            , public global: GlobalProvider
            , public http: HttpClient
            , public formbuilder: FormBuilder) {

    this.btnColor = this.navParams.get('btnColor');
    this.emailTXT = this.navParams.get('email');
    this.portal = this.navParams.get('agencyid');
    
    
    this.formgroup = formbuilder.group({
      email: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])]
    });

    this.email = this.formgroup.controls['email'];

  }
  SendReminderMail(){

    if(!this.formgroup.valid) { this.global.presentToast('Invalid Email'); return; }
  
    var p:any = {};
    //p.sp_name = "sp_password_reminder";
    p.username = this.email.value;
    p.portal = this.portal;

    const params = new HttpParams().set('j', JSON.stringify(p))

    this.http.post('login/forgot_password/', params)
    .subscribe((data: any) =>
    {
      this.showEmail = false;
      this.cardcontent = 'An email has been sent to your email address with instructions to reset your password.<br><br> If you do not receive this email please check your spam folders or it maybe that we do not have you registered on this system.<br><br> Please contact us if you are still having problems logging on.';
    },
    error =>
    { 
      this.global.presentToast('An error occurred!');
      console.log(error);
    });
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPasswordPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts